import React from 'react';
import { useTranslation } from 'react-i18next';

// Types
import { ContainerProps } from './types';

// Styled Components
import { Container, IconContainer, Text } from './styles';

// Icons
import { CheckIcon } from '../../../assets/icons/CheckIcon';
import { useTheme } from 'styled-components';

export const SuccessToast = ({ text, ...props }: ContainerProps) => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  return (
    <Container {...props}>
      <IconContainer>
        <CheckIcon width={24} height={24} fill={theme.colors.green as string} />
      </IconContainer>
      <Text size="M" variant="medium">
        {text || t('messages.success')}
      </Text>
    </Container>
  );
};
